import * as React from 'react';
import {styled} from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, {drawerClasses} from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import MenuContent from './MenuContent';
import {ReactComponent as GNBLogo} from '../gnb-logo.svg';
import {useEffect, useState} from "react";
import {useCookies} from "react-cookie";

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
    width: drawerWidth,
    flexShrink: 0,
    boxSizing: 'border-box',
    mt: 10,
    [`& .${drawerClasses.paper}`]: {
        width: drawerWidth,
        boxSizing: 'border-box',
    },
});

export default function SideMenu({ selected }) {
    const [cookies] = useCookies(['session-token']);
    const [userInfo, setUserInfo] = useState({
        displayName: 'Loading...',
        email: '...',
        avatar: 'avatar_robot.jpg'
    });

    useEffect(() => {
        const token = cookies['session-token'];
        if (token) {
            fetch('/api/user_info', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ session: token })
            })
            .then(res => {
                if (!res.ok) {
                    throw new Error('Failed to fetch user info');
                }
                return res.json();
            })
            .then(data => {
                if (data.displayName) {
                    setUserInfo(data);
                }
            })
            .catch(err => console.error("Error fetching user info:", err));
        }
    }, [cookies]);

    return (
        <Drawer
            variant="permanent"
            sx={{
                display: {xs: 'none', md: 'block'},
                [`& .${drawerClasses.paper}`]: {
                    backgroundColor: 'background.paper',
                },
            }}
        >
            <Box
                sx={{
                    overflow: 'auto',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <GNBLogo style={{width: '100%', height: 'auto', marginBottom: '3em'}}/>
                <Divider/>
                <MenuContent selected={selected.selected}/>
            </Box>
            <Stack
                direction="row"
                sx={{
                    p: 2,
                    gap: 1,
                    alignItems: 'center',
                    borderTop: '1px solid',
                    borderColor: 'divider',
                }}
            >
                <Avatar
                    sizes="small"
                    alt={userInfo.displayName}
                    src={`/${userInfo.avatar}`}
                    sx={{width: 36, height: 36}}
                    onError={(e) => { e.target.onerror = null; e.target.src='https://placehold.co/36x36/0284c7/FFFFFF?text=GNB'; }}
                />
                <Box sx={{mr: 'auto'}}>
                    <Typography variant="body2" sx={{fontWeight: 500, lineHeight: '16px'}}>
                        {userInfo.displayName}
                    </Typography>
                    <Typography variant="caption" sx={{color: 'text.secondary'}}>
                        {userInfo.email}
                    </Typography>
                </Box>
            </Stack>
        </Drawer>
    );
}